import { useMemo } from "react";
import { Breadcrumb } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigationGuard } from "../../../../contexts/NavigationGuardContext";

export default function BreadcrumbAdmin() {
    const location = useLocation();
    const { t, i18n } = useTranslation(['admin', 'claimRequestType', 'userCommunicationType']);
    const { navigateWithGuard } = useNavigationGuard();

    const breadcrumbPatterns = useMemo(() => [
        { pattern: /^\/admin$/, label: t("admin:routes.breadcrumbAdmin") },
        { pattern: /^\/admin\/client$/, label: t("admin:routes.breadcrumbAdminClientList") },
        { pattern: /^\/admin\/client\/new-client$$/, label: t("admin:routes.breadcrumbAdminClientNew") },
        { pattern: /^\/admin\/survey-load$/, label: t("admin:routes.breadcrumbAdminSurveyLoadList") },
        { pattern: /^\/admin\/survey-load\/new-survey-load$/, label: t("admin:routes.breadcrumbAdminSurveyLoadNew") },
        { pattern: /^\/admin\/survey-load\/detail-survey-load\/[^/]+$/, label: t("admin:routes.breadcrumbAdminDetailSurveyLoad") },
        { pattern: /^\/admin\/template$/, label: t("admin:routes.breadcrumbAdminTemplateList") },
        { pattern: /^\/admin\/template\/new-template$/, label: t("admin:routes.breadcrumbAdminTemplateCreate") },
        { pattern: /^\/admin\/users$/, label: t("admin:routes.breadcrumbAdminUserList") },
        { pattern: /^\/admin\/users\/new-user$$/, label: t("admin:routes.breadcrumbAdminUserCreate") },
        { pattern: /^\/admin\/campaign$/, label: t("admin:routes.breadcrumbAdminCampaignList") },
        { pattern: /^\/admin\/campaign\/new-campaign$/, label: t("admin:routes.breadcrumbAdminCampaignNew") },
        { pattern: /^\/admin\/event$/, label: t("admin:routes.breadcrumbAdminEventList") },
        { pattern: /^\/admin\/event\/new-event$/, label: t("admin:routes.breadcrumbAdminEventCreate") },
        { pattern: /^\/admin\/participants/, label: t("admin:routes.breadcrumbAdminParticipantsList") },
        { pattern: /^\/admin\/surveyList/, label: t("admin:routes.breadcrumbAdminSurveyList") },
        { pattern: /^\/admin\/claimReopenReason/, label: t("admin:routes.breadcrumbAdminMotiuReobrirQueixa") },
        { pattern: /^\/admin\/surveyClosedReason/, label: t("admin:routes.breadcrumbAdminSurveyClosedReason") },
        { pattern: /^\/admin\/claimProfessionalType/, label: t("admin:routes.breadcrumbAdminClaimProfessionalType") },
        { pattern: /^\/admin\/claimOrigin/, label: t("admin:routes.breadcrumbAdminClaimOrigin") },
        { pattern: /^\/admin\/demandInFormat/, label: t("admin:routes.breadcrumbAdminDemandInFormat") },
        { pattern: /^\/admin\/alertDeleteReason/, label: t("admin:routes.breadcrumbAdminAlertDeleteReason") },
        { pattern: /^\/admin\/claimDeleteReason/, label: t("admin:routes.breadcrumbAdminClaimDeleteReason") },
        { pattern: /^\/admin\/improvementPlanType/, label: t("admin:routes.breadcrumbAdminImprovementPlanType") },
        { pattern: /^\/admin\/improvementPlanOrigin/, label: t("admin:routes.breadcrumbAdminImprovementPlanOrigin") },
        { pattern: /^\/admin\/improvementPlanFinalizeReasons/, label: t("admin:routes.breadcrumbAdminImprovementPlanFinalizeReason") },
        { pattern: /^\/admin\/improvementPlanDeleteReasons/, label: t("admin:routes.breadcrumbAdminImprovementPlanDeleteReason") },
        { pattern: /^\/admin\/functionalAreas/, label: t("admin:routes.breadcrumbAdminFunctionalAreas") },
        { pattern: /^\/admin\/surveyPreviousClosed/, label: t("admin:routes.breadcrumbAdminSurveyPreviousClosed") },
        { pattern: /^\/admin\/serviceIndicators/, label: t("admin:routes.breadcrumbAdminServiceIndicators") },
        { pattern: /^\/admin\/newGeneric\/serviceIndicators/, label: t("admin:routes.breadcrumbAdminServiceIndicatorsNew") },
        { pattern: /^\/admin\/alertValues\/new-alert-value/, label: t("admin:routes.breadcrumbAdminAlertValuesNew") },
        { pattern: /^\/admin\/alertValues\/edit\//, label: t("admin:routes.breadcrumbAdminAlertValuesEdit") },
        { pattern: /^\/admin\/alertValues/, label: t("admin:routes.breadcrumbAdminAlertValues") },
        { pattern: /^\/admin\/newGeneric\/surveyClosedReason/, label: t("admin:routes.breadcrumbAdminSurveyClosedReasonNew") },
        { pattern: /^\/admin\/newGeneric\/claimProfessionalType/, label: t("admin:routes.breadcrumbAdminClaimProfessionalTypeNew") },
        { pattern: /^\/admin\/newGeneric\/claimOrigin/, label: t("admin:routes.breadcrumbAdminClaimOriginNew") },
        { pattern: /^\/admin\/newGeneric\/demandInFormat/, label: t("admin:routes.breadcrumbAdminDemandInFormatNew") },
        { pattern: /^\/admin\/newGeneric\/alertDeleteReason/, label: t("admin:routes.breadcrumbAdminAlertDeleteReasonNew") },
        { pattern: /^\/admin\/newGeneric\/functionalAreas/, label: t("admin:routes.breadcrumbAdminFunctionalAreasNew") },
        { pattern: /^\/admin\/newGeneric\/improvementPlanType/, label: t("admin:routes.breadcrumbAdminImprovementPlanTypeNew") },
        { pattern: /^\/admin\/newGeneric\/improvementPlanOrigin/, label: t("admin:routes.breadcrumbAdminImprovementPlanOriginNew") },
        { pattern: /^\/admin\/newGeneric\/improvementPlanFinalizeReasons/, label: t("admin:routes.breadcrumbAdminImprovementPlanFinalizeReasonNew") },
        { pattern: /^\/admin\/newGeneric\/improvementPlanDeleteReasons/, label: t("admin:routes.breadcrumbAdminImprovementPlanDeleteReasonNew") },
        { pattern: /^\/admin\/newGeneric\/claimReopenReason/, label: t("admin:routes.breadcrumbAdminMotiuReobrirQueixaNew") },
        { pattern: /^\/admin\/newGeneric\/claimDeleteReason/, label: t("admin:routes.breadcrumbAdminClaimDeleteReasonNew") },
        { pattern: /^\/admin\/auditLogs/, label: t("admin:routes.breadcrumbAdminAuditList") },
        { pattern: /^\/admin\/generic-params/, label: t("admin:routes.breadcrumbAdminGenericParams") },
        { pattern: /^\/admin\/roles$/, label: t("admin:routes.breadcrumbAdminRoleList") },
        { pattern: /^\/admin\/roles\/new-role$$/, label: t("admin:routes.breadcrumbAdminRoleNew") },
        { pattern: /^\/admin\/improvement-plans$/, label: t("admin:routes.breadcrumbAdminImprovementPlanList") },
        { pattern: /^\/admin\/claimFollowUpType$/, label: t("admin:routes.breadcrumbAdminclaimFollowUpType") },
        { pattern: /^\/admin\/claimCancelReason/, label: t("admin:routes.breadcrumbAdminClaimCancelReason") },
        { pattern: /^\/admin\/newGeneric\/claimCancelReason/, label: t("admin:routes.breadcrumbAdminClaimCancelReasonNew") },
        { pattern: /^\/admin\/demandOutFormat$/, label: t("admin:routes.breadcrumbAdminDemandOutFormat") },
        { pattern: /^\/admin\/newGeneric\/demandOutFormat/, label: t("admin:routes.breadcrumbAdminDemandOutFormatNew") },
        { pattern: /^\/admin\/demandDerivation$/, label: t("admin:routes.breadcrumbAdminDemandDerivation") },
        { pattern: /^\/admin\/topics$/, label: t("admin:routes.breadcrumbAdminTopics") },
        { pattern: /^\/admin\/sentiment-analysis$/, label: t("admin:routes.breadcrumbAdminSentimentAnalysis") },
        { pattern: /^\/admin\/sentiment-analysis\/new-sentiment/, label: t("admin:routes.breadcrumbAdminSentimentAnalysisNew") },
        { pattern: /^\/admin\/sentiment-analysis\/edit\//, label: t("admin:routes.breadcrumbAdminSentimentAnalysisEdit", { defaultValue: "Edit sentiment analysis" }) },
        { pattern: /^\/admin\/ips$/, label: t("admin:routes.breadcrumbAdminIPs") },
        { pattern: /^\/admin\/ips\/new-ips$/, label: t("admin:routes.breadcrumbAdminNewIPs") },
        { pattern: /^\/admin\/extraFields$/, label: t("admin:routes.breadcrumbAdminExtraFields") },
        { pattern: /^\/admin\/extraFields\/[^/]+$/, label: t("admin:routes.breadcrumbAdminExtraFieldEdit") },
        { pattern: /^\/admin\/claimPersonalRelationship/, label: t("admin:routes.breadcrumbAdminClaimPersonalRelationship") },
        { pattern: /^\/admin\/newGeneric\/claimPersonalRelationship/, label: t("admin:routes.breadcrumbAdminClaimPersonalRelationshipNew") },
        { pattern: /^\/admin\/claimRequestTypes$/, label: t("claimRequestType:title") },
        { pattern: /^\/admin\/organizationalStructures$/, label: t("admin:routes.breadcrumbAdminOrganizationalStructures") },
        { pattern: /^\/admin\/userCommunicationTypes$/, label: t("userCommunicationType:title") },
        { pattern: /^\/admin\/campaignClosedReason/, label: t("admin:routes.breadcrumbAdmincampaignClosedReason") },
        { pattern: /^\/admin\/newGeneric\/campaignClosedReason/, label: t("admin:routes.breadcrumbAdmincampaignClosedReasonNew") },
        { pattern: /^\/admin\/report-definitions$/, label: t("admin:routes.breadcrumbAdminReportDefinitionList") },
        { pattern: /^\/admin\/report-definitions\/new$/, label: t("admin:routes.breadcrumbAdminReportDefinitionNew") },

    ], [t, i18n.language]);

    const getBreadcrumbLabel = (path: string) => {
        const match = breadcrumbPatterns.find(({ pattern }) => pattern.test(path));
        return match ? match.label : null;
    };

    const paths = location.pathname.split("/").filter(Boolean);
    let accumulatedPath = "";
    const breadcrumbs = [];

    for (let i = 0; i < paths.length; i++) {

        accumulatedPath += `/${paths[i]}`;

        const currentPath = accumulatedPath;

        const label = getBreadcrumbLabel(currentPath);

        const isLast = i === paths.length - 1;

        if (!label && !isLast) continue;

        breadcrumbs.push(
            <Breadcrumb.Item
                key={currentPath}
                active={isLast}
                href="#"
                onClick={(e) => {

                    e.preventDefault();

                    if (!isLast) {

                        navigateWithGuard(currentPath);
                    }
                }}
                style={{
                    cursor: !isLast
                        ? "pointer"
                        : "default"
                }}
            >
                {label || paths[i]}
            </Breadcrumb.Item>
        );
    }

    return (
        <Breadcrumb>
            <ol className="breadcrumb breadcrumb-chevron pt-1 pb-3 rounded-3">
                {breadcrumbs}
            </ol>
        </Breadcrumb>
    );
}
